import { FGStack, FGTypography } from "@fg/design-system";
import GQFlag from "components/GQFlag";
import { IActiveCountry } from "interfaces";
import React from "react";
import { InsightAndEventBadge } from "./EventDisplay";

export const CountryBadge = React.memo(
    ({ country }: { country: IActiveCountry }) => {
        return (
            <InsightAndEventBadge>
                <FGStack gap={4}>
                    <GQFlag countryId={country.id} size={16} />
                    <FGTypography
                        variant="body4"
                        tag="label"
                        cssStyle={{ whiteSpace: 'nowrap' }}>
                        {country.name}
                    </FGTypography>
                </FGStack>
            </InsightAndEventBadge>
        );
    }
);
